module.exports = __webpack_public_path__ + "static/media/Q1_figure.61c8d8d0.png";